<template>
  <Modal 
    class="qrcode-modal" 
    v-model:visible="open" 
    :title="$lang('寄件二维码')" 
    :ok-text="$lang('关闭')" 
    :cancel-button-props="{ style: { display: 'none' } }" 
    @ok="close" 
    @cancel="close">
    <div class="qrcode-container">
      <qrcode-vue
        :value="qrCodeValue"
        :level="level"
        :render-as="renderAs"
        :size="150"/>
      <div class="station-code">{{ authStore?.userInfo?.stationCode }}</div>
      <div class="qrcode-tips">{{ $lang('扫描二维码，自助下单') }}</div>
    </div>
  </Modal>
</template>
<script lang="ts" setup name="QrCodeModal">
import { onMounted, ref } from 'vue';
import { Modal } from 'ant-design-vue';
import QrcodeVue, { Level, RenderAs } from 'qrcode.vue'
import commonService from '@/service/api/common'
import { useAuthStore, useTabStore, useSettingStore } from '@/store'
import { isSuccess } from '@/utils'
const authStore = useAuthStore()
interface Props {
  open?: boolean
}
const props = defineProps<Props>()
const emit = defineEmits(['update:visible'])
const open = ref<boolean>(props.open);
const qrCodeValue = ref('https://www.baidu.com')
const level = ref<Level>('M')
const renderAs = ref<RenderAs>('canvas')
const close = () => {
  emit('update:visible', false)
}

/**
 * 获取二维码链接
 */
const getQrCodeUrl = async () => {
  const res = await commonService.getQrCodeUrl()
  if (!isSuccess(res)) return
  qrCodeValue.value = res.data
}

onMounted(() => {
  getQrCodeUrl()
})
</script>
<style lang="less" scoped>
:global(.ant-modal-title) {
  font-size: 20px !important;
  font-weight: 700;
}
.qrcode-container{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 10px;
  .station-code{
    margin-top: 10px;
    color: #9499a3;
  }
  .qrcode-tips{
    margin-top: 10px;
    color: #9499a3;
  }
}
</style>